export const getOnIconPressHandler =
  ({onIconPress, navigateBack, handleShowCreateCandidate}: any) =>
  (iconName: any) => {
    if (iconName === 'chevron-left') {
      navigateBack();
    }
    if (iconName === 'plus') {
      handleShowCreateCandidate();
    }

    onIconPress(iconName);
  };
